import React from 'react';

const ConfirmationModal = ({ open, phaseTitle, onCancel, onConfirm, darkMode, theme }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className={`rounded-lg shadow-2xl p-6 max-w-md w-full mx-4 ${theme.panel}`}>
        <h2 className="text-2xl font-bold text-red-600 mb-3">⚠️ Final Submission</h2>
        <p className={`mb-4 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
          You are about to submit your responses for phase <strong>{phaseTitle}</strong>.
        </p>
        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className={`px-4 py-2 rounded-lg font-semibold ${darkMode ? 'bg-gray-700 hover:bg-gray-600 text-white' : 'bg-gray-200 hover:bg-gray-300 text-gray-900'}`}
          >
            Cancel
          </button>
          <button onClick={onConfirm} className="px-4 py-2 rounded-lg bg-green-600 hover:bg-green-700 text-white font-semibold">
            Yes, Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;